import React from "react";

const LanguageModal = ({ onSelect }) => {
  return (
    <div className="lang-modal-overlay">
      <div className="lang-modal">
        <p className="lang-modal__title">
          <span>Выберите язык</span>
          <span className="lang-modal__dot">·</span>
          <span>Оберіть мову</span>
          {/* <span className="lang-modal__dot">·</span>
          <span>Choose language</span> */}
        </p>
        <div className="lang-modal__buttons">
          <button onClick={() => onSelect("ru")}>Русский</button>
          <button onClick={() => onSelect("uk")}>Українська</button>
          {/* <button onClick={() => onSelect("en")}>English</button> */}
        </div>
      </div>
    </div>
  );
};

export default LanguageModal;
